module.exports = __webpack_public_path__ + "media/assets/images/blog/amazed-formal-male-looking-at-laptop-3ff3d7f111451d2b9d1c0bc907beb69f.jpg";